// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NewPlant, Plant, type PlantWireFormat } from '../Plant/Plant';
import { NewProduct, Product, type ProductWireFormat } from '../Product/Product';

export class QuoteConfigProduct {
  readonly product: Product;
  readonly usage: string | null;
  readonly location: Plant;
  readonly externalName: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.product = NewProduct(data.product);
    this.usage = data.usage === undefined ? null : data.usage;
    this.location = NewPlant(data.location);
    this.externalName = data.externalName === undefined ? null : data.externalName;
  }

  static zero(): QuoteConfigProduct {
    const zeroValues: ExcludeMethodsDeep<QuoteConfigProduct> = {
      product: Product.zero(),
      usage: null,
      location: Plant.zero(),
      externalName: null,
    };
    return new QuoteConfigProduct(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteConfigProductWireFormat = {
  product: ProductWireFormat;
  usage: string | null;
  location: PlantWireFormat;
  externalName: string | null;
};

type NewQuoteConfigProductProps = PartialDeep<QuoteConfigProduct, { recurseIntoArrays: true }>;
export const NewQuoteConfigProduct: (props: NewQuoteConfigProductProps) => QuoteConfigProduct = (
  props,
) => new QuoteConfigProduct(props);

type NewQuoteConfigProductFromWireFormatProps = PartialDeep<
  QuoteConfigProductWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteConfigProductFromWireFormat: (
  props: NewQuoteConfigProductFromWireFormatProps,
) => QuoteConfigProduct = (props) => new QuoteConfigProduct(props);
